import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { useNavigate } from 'react-router';

export const useCreateNewPassword = (): {
  isLoading: boolean;
  createNewPassword: (body: { password: string }) => void;
} => {
  const navigate = useNavigate();

  const { isLoading, error, status, send } = useRequest({
    url: '/api/v1/auth/me',
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
    body: {},
  });

  const createNewPassword = (body: { password: string }) => {
    if (body.password) {
      send({ ...body });
    }
  };

  if (!error && status === 200) {
    navigate('/auth/choose-your-role', { replace: true });
  }

  return { isLoading, createNewPassword };
};
